import React from 'react'
import classNames from 'classnames'

import Icon from '../../../../shared/components/atoms/Icon'

const Sample = ({ product, chosenProduct, addChosenProduct, cart }) => {
  const activeStatus = cart?.items?.find(item => item.sku === chosenProduct?.sku) || ''

  return (
    <div className='sample-container' key={product.sku} onClick={() => addChosenProduct(product)}>
      <div className='sample-img'>
        <img src={product.image_url} />
        <img src='https://cdn.shopify.com/s/files/1/1956/4693/files/rond_imparfait_02.png?v=1623424029' className='imperfect' />
      </div>
      <div className='sample-title'>{product.title}</div>
      <label className='sample-checkbox'>
        <span className={classNames('sample-circle', { checked: activeStatus?.sku === product?.sku })}>
          {activeStatus?.sku === product?.sku && <Icon iconName='circle' />}
        </span>
      </label>
    </div>
  )
}

export default Sample
